import { track, Vec2d } from '@tldraw/tldraw'
import Styles from './ContextToolbar.module.scss'
import { PropsWithChildren } from 'react'
import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import { pageToViewport } from '../../../helpers'
import { useToolbarPlacement } from './useToolbarPlacement'

const TOOLBAR_HEIGHT = 36
const OFFSET = 8

export const Toolbar = track(({ children }: PropsWithChildren) => {
  const placement = useToolbarPlacement()
  const editor = useEditor()

  const selectionRotatedPageBounds = editor.getSelectionRotatedPageBounds()
  if (!selectionRotatedPageBounds) return null

  const topCenter = new Vec2d(selectionRotatedPageBounds.center.x, selectionRotatedPageBounds.y)
  const bottomCenter = new Vec2d(selectionRotatedPageBounds.center.x, selectionRotatedPageBounds.maxY)

  const viewportTopCenter = pageToViewport(editor, topCenter)
  const viewportBottomCenter = pageToViewport(editor, bottomCenter)

  let style = {}

  if (placement === 'top') {
    style = {
      top: Math.max(viewportTopCenter.y - TOOLBAR_HEIGHT - OFFSET, 0 + OFFSET),
      left: viewportTopCenter.x,
      translate: `-50% 0`,
    }
  }

  if (placement === 'bottom') {
    style = {
      top: viewportBottomCenter.y + OFFSET,
      left: viewportBottomCenter.x,
      translate: '-50% 0',
    }
  }

  return (
    <div onPointerDown={(e) => e.stopPropagation()} className={Styles.toolbar} style={style}>
      {children}
    </div>
  )
})
